var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDrop } from 'react-dnd';
import UserBox from './userBox';
import { ItemTypes } from './types';
import { useAppDispatch } from '../../../store';
import { updateBreakoutRoomDroppedUser } from '../../../store/slices/breakoutRoomSlice';
export const RoomBox = ({ roomId, name, users }) => {
    _react_refresh_temp_2();
    const dispatch = useAppDispatch();
    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        accept: ItemTypes.USER,
        drop: (item) => {
            dispatch(updateBreakoutRoomDroppedUser({
                id: item.id,
                roomId: roomId,
            }));
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }));
    const isActive = canDrop && isOver;
    let backgroundColor = 'bg-white dark:bg-darkPrimary';
    if (isActive) {
        backgroundColor = 'bg-primaryColor';
    }
    else if (canDrop) {
        backgroundColor = 'bg-secondaryColor';
    }
    return (_jsxs("div", { ref: drop, 
        // style={{ backgroundColor }}
        className: `roomBox scrollBar scrollBar2 overflow-hidden overflow-y-auto h-60 w-full sm:w-[13rem] lg:w-[13.2rem] xl:w-[13.75rem] ltr:mr-4 lg:ltr:mr-6 rtl:ml-4 lg:rtl:ml-6 mb-2 sm:mb-6  border border-solid border-black dark:border-darkText ${backgroundColor}`, children: [_jsx("p", { className: `text-sm sm:text-base  px-2 py-1 border-b-2 border-solid
        ${isActive || canDrop
                    ? 'text-white border-white'
                    : 'text-black dark:text-darkText border-black dark:border-darkText'}`, children: name }), users.map((user) => {
                return (_jsx("div", { children: _jsx(UserBox, { name: user.name, id: user.id }) }, user.id));
            })] }));
};
_react_refresh_temp_1 = RoomBox;
$RefreshReg$(_react_refresh_temp_1, "RoomBox");
_react_refresh_temp_2(RoomBox, "PW9reZzWgAmHsLOcj5TW/s1sAnM=", false, () => [useAppDispatch, useDrop]);
